<template>
  <div class="s-strip s-leasing-offers-compare d-none d-lg-block">
    <div class="page-container">
      <div class="row gx-5 mb-80">
        <div class="col-3">
          <div class="s-leasing-offers-compare__back">
            <button
              type="button"
              class="btn btn-link btn-icon-start"
              @click="onClickBack">
              <i class="icon-arrow-long-left"></i>
              {{ dictionary.backButtonText }}
            </button>
          </div>
        </div>
        <!-- col -->
        <div
          v-for="item in records"
          :key="item"
          ref="thresholdElement"
          class="col-3">
          <VehicleCompareCard :item="item" @change-vat="onToggleVatIncluded" />
          <button
            type="button"
            class="btn btn-link btn-remove"
            :disabled="records.length < 3"
            @click="removeVehicle(item.id)">
            {{ dictionary.removeVehicleButtonText }}
          </button>
        </div>
      </div>

      <div class="b-tech-characteristics-table mb-40">
        <div class="row gx-5">
          <div class="col-3">
            <span>{{ dictionary.paymentInAdvanceLabel }}:</span>
          </div>
          <div v-for="item in records" :key="item.id" class="col-3">
            <span v-if="!item.vatIncluded">
              {{ priceHasValue(item.paymentInAdvance) }}
            </span>
            <span v-else class="highlight">
              {{ priceHasValue(item.paymentInAdvanceIncldVat) }}
            </span>
          </div>
        </div>
        <div class="row gx-5">
          <div class="col-3">
            <span>{{ dictionary.retailPriceLabel }}:</span>
          </div>
          <div v-for="item in records" :key="item" class="col-3">
            <span>{{ item.retailPrice }}</span>
          </div>
        </div>
        <div class="row gx-5">
          <div class="col-3">
            <span>{{ dictionary.retailPriceBeforeTaxesLabel }}:</span>
          </div>
          <div v-for="item in records" :key="item" class="col-3">
            <span>
              {{ item.retailPriceBeforeTaxes }}
            </span>
          </div>
        </div>
      </div>

      <AccordionLarge
        :title="dictionary.techTitle"
        :is-active-prop="true"
        class="theme-grey theme-icon-cirle mb-40">
        <div class="b-tech-characteristics-table">
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.transmissionLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.transmissionType }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.fuelLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.fuel }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.consumptionLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>
                {{ item.consumption }}
              </span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.emissionsLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.emissions }}</span>
            </div>
          </div>
        </div>
      </AccordionLarge>

      <AccordionLarge
        :title="dictionary.equipmentTitle"
        :is-active-prop="true"
        class="theme-grey theme-icon-cirle mb-80">
        <div style="padding: 20px">
          <div class="row gx-5">
            <div class="col-3"></div>
            <!-- col -->
            <div
              v-for="item in records"
              :key="item"
              v-auto-animate
              class="col-3">
              <ul class="is-checked">
                <li v-for="(spec, index) in getSpecs(item)" :key="index">
                  {{ spec }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </AccordionLarge>
    </div>
  </div>

  <Transition ref="stickyElement">
    <VehiclesStickyBar :records="recordsCompare" @click-back="onClickBack" />
  </Transition>

  <LeasingCompareOffersSlick class="d-block d-lg-none" />
</template>

<script>
import * as lib from './../../lib/lib'
import constants from './../../lib/constants'
import VehicleCompareCard from './../components/leasingOffers/VehicleCompareCard.vue'
import AccordionLarge from './../components/BookingAccordion.vue'
import LeasingCompareOffersSlick from './LeasingCompareOffersSlick.vue'
import mixinsLeasingOffers from '../mixins/leasingOffers-mixins'
import VehiclesStickyBar from '../components/leasingOffers/VehiclesStickyBar.vue'
import StickyOnScroll from './../../modules/StickyOnScroll.js'

export default {
  components: {
    AccordionLarge,
    VehicleCompareCard,
    LeasingCompareOffersSlick,
    VehiclesStickyBar,
  },
  mixins: [mixinsLeasingOffers],
  data() {
    return {
      records: [],
    }
  },
  mounted() {
    const { records } = lib.getData('leasingCompareData')
    this.records = records
    this.records.forEach((x) => (x.vatIncluded = false))

    this.setField({ field: 'recordsCompare', value: this.records })

    this.$nextTick(() => {
      this.stickyOnScroll = new StickyOnScroll(
        this.$refs.stickyElement,
        this.$refs.thresholdElement
      )
    })
  },
  methods: {
    priceHasValue(price) {
      if (price === null || price === undefined) return '-'
      if (price.length <= 1) return '-'

      const priceWithoutEuroSign = price.slice(1)

      return priceWithoutEuroSign > 0 ? price : '-'
    },
    removeVehicle(id) {
      this.records = this.records.filter((x) => x.id !== id)
    },
    getSpecs(value) {
      return value.characteristics
    },

    getTransmissionLabel(value) {
      let res
      const { manual, auto } = constants.leaseitnow.filters.transmissionsOptions

      switch (value) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },

    onToggleVatIncluded(value, id) {
      this.records.find((x) => x.id === id).vatIncluded = value
    },
    onClickBack() {
      window.location.assign(
        `${this.configuration.fleetPageUrl}?vehicles=${this.records
          .map((x) => x.id)
          .join()}`
      )

      lib.scrollToTop()
    },
  },
}
</script>
